/**
 * The six fulfillment sub-views, in the same order the Supply Planner
 * fulfillment workspace presents them.
 */
export const FULFILLMENT_TABS = [
  {
    path: '/sales-order-backlog',
    label: 'Sales Order Backlog',
    module: 'tabs/BacklogTab',
  },
  {
    path: '/projects',
    label: 'Project Orders',
    module: 'tabs/ProjectsTab',
  },
  {
    path: '/plant-view',
    label: 'Plant View',
    module: 'tabs/PlantViewTab',
  },
  {
    path: '/weekly-tracking',
    label: 'Weekly Tracking',
    module: 'tabs/TrackingTab',
  },
  {
    path: '/atp',
    label: 'ATP',
    module: 'tabs/AtpTab',
  },
  {
    path: '/executive-summary',
    label: 'Executive Summary',
    module: 'tabs/ExecSummaryTab',
  },
];

/**
 * Auxiliary fulfillment routes that sit alongside the operational pages.
 */
export const FULFILLMENT_AUX_ROUTES = [
  {
    path: '/uploads',
    label: 'Uploads',
    module: 'uploads/UploadsPage',
  },
];

/**
 * Compatibility metadata for callers that still need to treat fulfillment as
 * one workspace.
 */
export const FULFILLMENT_WORKSPACE = {
  path: '/sales-order-backlog',
  label: 'Fulfillment',
  paths: [...FULFILLMENT_TABS.map((tab) => tab.path), ...FULFILLMENT_AUX_ROUTES.map((r) => r.path)],
};

/**
 * Old in-app tab URLs → their new top-level pages.
 *
 * These were real, bookmarkable URLs for a while. Redirecting rather than
 * 404-ing costs one line each and saves anyone who saved a link.
 */
export const LEGACY_REDIRECTS = {
  // '/backlog' was the home route until the page was renamed to Sales Order
  // Backlog, which makes it the most-bookmarked path in the app. It redirects
  // rather than falling through to the catch-all so a saved link keeps working.
  '/backlog': '/sales-order-backlog',
  '/fulfillment': '/sales-order-backlog',
  '/fulfillment/backlog': '/sales-order-backlog',
  '/fulfillment/projects': '/projects',
  '/fulfillment/plant': '/plant-view',
  '/fulfillment/tracking': '/weekly-tracking',
  '/fulfillment/atp': '/atp',
  '/fulfillment/exec': '/executive-summary',
};
